import React, { useEffect, useRef } from 'react';
import { useGlobalContext } from '../../js/context';
import anime from 'animejs/lib/anime.es.js';
import { gtmTracking, gtm4Tracking } from '../../js/helpers';
import './Sidebar.scss';

const Sidebar = () => {
	const { products, productClickHandler, singleProduct, page } =
		useGlobalContext();
	const sideBarListRef = useRef();
	const sidebarRef = useRef();
	const itemRefs = {};

	useEffect(() => {
		if (singleProduct?.id) {
			itemRefs[singleProduct.id].scrollIntoView({
				behavior: 'auto',
				block: 'center',
				inline: 'center',
			});
			window.scrollTo(0, 0);
		}

		const tl = anime.timeline({
			easing: 'easeOutExpo',
			duration: 500,
		});

		tl.add({
			targets: sidebarRef.current,
			translateX: [-150, 0],
			opacity: [0, 1],
			delay: 250,
		});
		//eslint-disable-next-line
	}, []);

	const sideScroll = (direction, distance, step) => {
		let scrollAmount = 0;

		const slideTimer = setInterval(() => {
			if (direction === 'top') {
				sideBarListRef.current.scrollTop -= step;
			} else {
				sideBarListRef.current.scrollTop += step;
			}
			scrollAmount += step;

			if (scrollAmount >= distance) {
				window.clearInterval(slideTimer);
			}
		}, 10);
	};

	const scrollUp = () => {
		sideScroll('top', 272, 10);
	};
	const scrollDown = () => {
		sideScroll('bottom', 272, 10);
	};

	const activeElementFocusHandler = (e) => {
		if (e.keyCode === 115 || e.code === 'KeyS') {
			Array.from(sideBarListRef.current.children).forEach((element) => {
				if (element) {
					if (element.classList.contains('tos-sidebar__button--active')) {
						element.firstChild.focus();
					}
				}
			});
		}
	};

	const activeElementTooltipFocusHandler = () => {
		Array.from(sideBarListRef.current.children).forEach((element) => {
			if (element) {
				if (element.classList.contains('tos-sidebar__button--active')) {
					element.addEventListener('keypress', (e) => {
						if (e.keyCode === 13 || e.code === 'Enter') {
							const btnTooltip = document.querySelector('.tos-tooltip__icon');
							if (btnTooltip) {
								btnTooltip.focus();
							}
						}
					});
				}
			}
		});
	};

	useEffect(() => {
		if (page && page === 'element_page') {
			document.addEventListener('keypress', activeElementFocusHandler);
			activeElementTooltipFocusHandler();
		}
		return () => {
			document.removeEventListener('keypress', activeElementFocusHandler);
		};
	}, [singleProduct, page]);

	return (
		<div className='tos-sidebar' ref={sidebarRef}>
			<button
				className='tos-sidebar__button tos-sidebar__button--top'
				onClick={scrollUp}
			>
				<svg
					width='15'
					height='15'
					viewBox='0 0 15 15'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M7.5 1.95L6.13786e-08 9.42319L1.0798 10.5L7.51704 4.05557L13.9372 10.4829L15 9.42319L7.5 1.95Z'
						fill='white'
					/>
				</svg>
			</button>
			<ul className='tos-sidebar__list' ref={sideBarListRef}>
				{products.map((product) => {
					return (
						<li
							key={product.id}
							ref={(el) => (itemRefs[product.id] = el)}
							className={`${
								singleProduct?.name === product.name
									? 'tos-sidebar__button--active'
									: ''
							}`}
						>
							<button
								onClick={(e) => {
									productClickHandler(product.name);
									gtm4Tracking({
										event: 'GA4_event_c_tfs_constituent_click',
										constituent_name: product.name,
										click_origin: 'constituent list'
									});
									gtmTracking('component list', product.name);
								}}
								className={`tos-sidebar__list-button ${
									singleProduct?.name === product.name
										? 'tos-sidebar__button--active'
										: ''
								}`}
							>
								<span
									className={`${
										product?.name.length >= 18
											? 'tos-sidebar__list-button--large'
											: ''
									}`}
								>
									{product.name}
								</span>
								{product.sub_title && (
									<small
										dangerouslySetInnerHTML={{
											__html: product?.sub_title,
										}}
									/>
								)}
							</button>
						</li>
					);
				})}
			</ul>
			<button
				className='tos-sidebar__button tos-sidebar__button--bottom'
				onClick={scrollDown}
			>
				<svg
					width='15'
					height='15'
					viewBox='0 0 15 15'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M7.5 13.05L15 5.57681L13.9202 4.5L7.48296 10.9444L1.06275 4.51706L1.58124e-09 5.57681L7.5 13.05Z'
						fill='white'
					/>
				</svg>
			</button>
		</div>
	);
};

export default Sidebar;
